module.exports = __webpack_public_path__ + "static/media/mobile-step3-en.f954dd63.png";